
import { Component, Vue } from 'vue-property-decorator';
import { TableHeaderConfig } from '@/views/interfaces/vuetify/table.interface';
import Themeable from 'vuetify/lib/mixins/themeable';
import { Roles } from '@/services/Roles';
import HasScope from '@/components/Mixins/HasScope';
import DepartmentRepositoryInterface, { DepartmentInterface } from '@/services/Departments/Interfaces';
import DeleteDepartmentDialog from '@/components/dialogs/departments/DeleteDepartmentDialog.vue';

@Component({
  mixins: [
    Themeable,
    HasScope,
  ],
  components: {
    DeleteDepartmentDialog,
  },
  inject: [
    'departmentRepository',
  ],
})
export default class AllDepartments extends Vue {
  private departmentRepository!: DepartmentRepositoryInterface

  private loading: boolean = true;
  private headers: TableHeaderConfig[] = [
    { text: 'ID', value: '_id' },
    { text: 'Name', value: 'name' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];
  private createDepartmentScope: string = Roles.USER_DEPARTMENTS_CREATE;
  private search: string = '';
  private departments: DepartmentInterface[] = [];
  private deleteDepartmentForDialog: DepartmentInterface | false = false;
  private deleteDepartmentDialog: string = '';

  private created(): void {
    this.initialize();
  }

  private async initialize(): Promise<void> {
    this.departments = await this.departmentRepository.getAllDepartments();
    this.loading = false;
  }

  private editDepartment(department: DepartmentInterface): void {
    this.$router.push({ name: 'department_edit', params: { departmentId: department._id } });
  }

  private deleteDepartment(department: DepartmentInterface): void {
    this.deleteDepartmentDialog = 'delete-department-dialog';
    this.deleteDepartmentForDialog = department;
  }

  private createDepartment(): void {
    this.$router.push({ name: 'department_create' });
  }

  private filterDepartments(departmentId: string): void {
    this.departments = this.departments.filter((department) => {
      return department._id !== departmentId;
    });
  }
}
